import { render } from "./AllMessagesView.vue?vue&type=template&id=3861acb9"
import script from "./AllMessagesView.vue?vue&type=script&lang=js"
export * from "./AllMessagesView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__